import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
  isFirst?: boolean;
}
function AccordionItem({
  title,
  children,
  isOpen,
  onClick,
  isFirst
}: AccordionItemProps) {
  return <div className={`border-b border-[#E8E8E8] ${isFirst ? 'border-t' : ''}`} data-id="element-330">
      <button onClick={onClick} className="w-full flex justify-between items-center py-5 text-left group" aria-expanded={isOpen} data-id="element-331">
        <span className="text-base font-medium text-[#1A1A1A] uppercase tracking-[0.1em] group-hover:text-[#D4A853] transition-colors" data-id="element-332">
          {title}
        </span>
        <span className="text-[#6B6B6B] group-hover:text-[#D4A853] transition-colors" data-id="element-333">
          {isOpen ? <Minus size={20} strokeWidth={1.5} data-id="element-334" /> : <Plus size={20} strokeWidth={1.5} data-id="element-335" />}
        </span>
      </button>
      <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-336">
        <div className="overflow-hidden" data-id="element-337">
          <div className="text-[#6B6B6B] font-['Raleway'] text-lg leading-relaxed pb-6" data-id="element-338">
            {children}
          </div>
        </div>
      </div>
    </div>;
}
export function ProductAccordion() {
  const [openSection, setOpenSection] = useState<string | null>('description');
  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };
  return <div className="pt-2" data-id="element-339">
      <AccordionItem title="Description" isOpen={openSection === 'description'} onClick={() => toggleSection('description')} isFirst data-id="element-340">
        Designed for the modern woman, this piece combines effortless elegance
        with everyday comfort. The silhouette is flattering and versatile,
        perfect for transitioning from day to evening. Features delicate
        detailing and premium finishing throughout.
      </AccordionItem>

      <AccordionItem title="Materials & Care" isOpen={openSection === 'materials'} onClick={() => toggleSection('materials')} data-id="element-341">
        <p className="mb-4" data-id="element-342">100% Premium Silk Blend</p>
        <p data-id="element-343">
          Dry clean only recommended to maintain the fabric's luster and shape.
          Store folded in a cool, dry place away from direct sunlight.
        </p>
      </AccordionItem>

      <AccordionItem title="Shipping & Returns" isOpen={openSection === 'shipping'} onClick={() => toggleSection('shipping')} data-id="element-344">
        <p className="mb-4" data-id="element-345">
          Free standard shipping on all US orders over $75. Orders are processed
          within 1-2 business days.
        </p>
        <p data-id="element-346">
          We accept returns of unworn items with original tags within 30 days of
          delivery.
        </p>
      </AccordionItem>
    </div>;
}